import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { ButtonPrimitive } from '../button-primitive/button-primitive.js';
import { Button as Button$1 } from '../buttons/button.js';
import '../buttons/dialog-trigger-button/dialog-trigger-button.js';
import '../buttons/icon-button/icon-button.js';
import '../buttons/toggle-button/toggle-button.js';
import { link } from '../link/link.css.js';
import { link as link$1 } from './banner.css.js';

/**
 * Button to be displayed inside of Banner
 *
 * @compose { "multi": true }
 */
const Button = forwardRef((props, ref) => {
    return jsx(Button$1, { "data-fpl-component": "", ref: ref, variant: "secondary", ...props });
});
Button.displayName = 'Banner.Button';
/**
 * Button.Link to be displayed inside of Banner
 *
 * @compose { "multi": true }
 */
const ButtonLink = forwardRef((props, ref) => (jsx(ButtonPrimitive, { "data-fpl-component": "", ref: ref, ...props, className: clsx(link, link$1) })));
ButtonLink.displayName = 'Banner.ButtonLink';

export { Button, ButtonLink };
//# sourceMappingURL=banner-button.js.map
